
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons/1.1",
      function () {
        return require("private-next-pages/lessons/1.1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons/1.1"])
      });
    }
  